<template>
  <div>
    <div class="mb-6 mt-2 flex justify-between">
      <div class="pr-5 text-lg font-medium text-gray-dark">
        Guests
      </div>

      <div class="flex">
        <a
          href="#"
          class="flex size-8 items-center justify-center rounded-full border border-body text-4xl"
          :class="{ 'border-gray-5': numGuestsLocal === minGuests, 'cursor-not-allowed': numGuestsLocal === minGuests, 'hover:border-black': numGuestsLocal !== minGuests }"
          :disabled="numGuestsLocal === minGuests"
          @click.prevent="numGuestsLocal--"
        >
          <svg
            width="12"
            height="2"
            viewBox="0 0 12 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3332 1.66683L0.666504 1.66683V0.333496L11.3332 0.333497V1.66683Z" fill="#808080" />
          </svg>
        </a>
        <input v-model="numGuestsLocal" class="mx-3 w-10 text-center text-xl text-gray-dark" type="text">
        <a
          href="#"
          class="flex size-8 items-center justify-center rounded-full border border-body text-4xl hover:border-black"
          :disabled="numGuestsLocal === maxGuests"
          @click.prevent="numGuestsLocal++"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6.6665 5.33317V0.666504H5.33317L5.33317 5.33317H0.666504V6.6665L5.33317 6.6665V11.3332H6.6665V6.6665L11.3332 6.66651V5.33317L6.6665 5.33317Z" fill="#808080" />
          </svg>
        </a>
      </div>
    </div>

    <div class="flex justify-between">
      <div class="pr-5 text-lg font-medium text-gray-dark">
        Rooms
      </div>

      <div class="flex">
        <a
          href="#"
          class="flex size-8 items-center justify-center rounded-full border border-body text-4xl"
          :class="{ 'border-gray-5': numRoomsLocal === minRooms, 'cursor-not-allowed': numRoomsLocal === minRooms, 'hover:border-black': numRoomsLocal !== minRooms }"
          :disabled="numRoomsLocal === minRooms"
          @click.prevent="numRoomsLocal--"
        >
          <svg
            width="12"
            height="2"
            viewBox="0 0 12 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3332 1.66683L0.666504 1.66683V0.333496L11.3332 0.333497V1.66683Z" fill="#808080" />
          </svg>
        </a>
        <input v-model="numRoomsLocal" class="mx-3 w-10 text-center text-xl text-gray-dark" type="text">
        <a
          href="#"
          class="flex size-8 items-center justify-center rounded-full border border-body text-center text-4xl hover:border-black"
          :disabled="numRoomsLocal === maxRooms"
          @click.prevent="numRoomsLocal++"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6.6665 5.33317V0.666504H5.33317L5.33317 5.33317H0.666504V6.6665L5.33317 6.6665V11.3332H6.6665V6.6665L11.3332 6.66651V5.33317L6.6665 5.33317Z" fill="#808080" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numRooms: { type: Number, required: true },
    numGuests: { type: Number, required: true },
    minGuests: { type: Number, required: true },
    maxGuests: { type: Number, required: true },
    minRooms: { type: Number, required: true },
    maxRooms: { type: Number, required: true },
  },

  emits: ['update:numGuests', 'update:numRooms'],

  data: () => ({
    numGuestsLocal: 0,
    numRoomsLocal: 0,
  }),

  watch: {
    numGuests (val) {
      this.numGuestsLocal = val
    },

    numRooms (val) {
      this.numRoomsLocal = val
    },

    numGuestsLocal (val) {
      let numGuests = Number.parseInt(val.toString().replace(/[^0-9]+/, ''))
      if (numGuests < this.minGuests) {
        numGuests = this.minGuests
      } else if (numGuests > this.maxGuests) {
        numGuests = this.minGuests
      }
      this.numGuestsLocal = numGuests
      this.$emit('update:numGuests', numGuests)
    },

    numRoomsLocal (val) {
      let numRooms = Number.parseInt(val.toString().replace(/[^0-9]+/, ''))
      if (numRooms < this.minRooms) {
        numRooms = this.minRooms
      } else if (numRooms > this.maxRooms) {
        numRooms = this.minRooms
      }
      this.numRoomsLocal = numRooms
      this.$emit('update:numRooms', numRooms)
    },
  },

  mounted () {
    this.numGuestsLocal = this.numGuests
    this.numRoomsLocal = this.numRooms
  },
}
</script>
